import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { ActionPopover } from 'components/Table/ActionTable';
import { showDateFormated } from 'utility/generic';

export function TableGeneric({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;

  return (
    <>
      <GlobalFilter
        filter={globalFilter}
        setFilter={setGlobalFilter}
        urlNewItem={'/city/new'}
      />
      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Nenhuma cidade cadastrada! Registre uma!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const CityList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric('/v1/city', 'GET');
      if (data !== undefined) {
        setProducts(data);
      }
    }

    getData();
  }, []);

  const cacheItemsDisabled = React.useMemo(() => products, [products]);

  const columns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Estado',
        accessor: 'state',
      },
      {
        Header: 'Última Atualização',
        accessor: 'lastUpdate',
        Cell: ({ cell: { value } }) => (
          <span>{`${showDateFormated(value)}`}</span>
        ),
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <ActionPopover
              urlEdit={'/city/' + actionId}
              urlDelete={'/v1/city/'}
              idDelete={actionId}
              listUpdate={setProducts}
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric columns={columns} data={cacheItemsDisabled} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
